import axios from './ApiConfig';

export default axios as any;
